import React from "react";
import { Select } from "antd";

import { useCurrencyContext } from "../../common/providers/CurrencyProvider";
import currencyList from "./currencyList";

const { Option } = Select;

const FlagsList = () => {
  const { activeCurrency, setActiveCurrency } = useCurrencyContext();

  return (
    <Select
      defaultValue={activeCurrency}
      onSelect={(val) => {
        setActiveCurrency(val);
      }}
      style={{ minWidth: 140 }}
    >
      {currencyList.map((item) => (
        <Option value={item.name} key={item.name}
        label={
        <span className="currency-option-label">
          <img src={item.url} alt={item.name} className="currency-flag-img" />{" "}
          <span className="currency-code">{item.name}</span>
          <span className="currency-symbol">{item.symbol}</span>
        </span>
        }>
          <div className="currency-option">
            <img src={item.url} alt={item.name} className="currency-flag-img" />
            <span className="currency-code">{item.name}</span>
            <span className="currency-symbol" style={{fontSize:'14px', color:'#000', marginLeft:"10px", padding:"5px"}}>{item.symbol}</span>
          </div>
        </Option>
      ))}
    </Select>
  );
};

export default FlagsList;
